import IWallMetaData from 'components/interfaces/IWallMetaData';

const getDefaultWallMetaData = (identifier = ''): IWallMetaData => ({
  doors: [],
  glassAreas: [],
  identifier,
  name: '',
  placed: false,
});

export default getDefaultWallMetaData;
